import MAccordionContent from "@modules/accordions/includes/_m-accordion-content";

let baseAccordionContent = {
    inheritAttrs: false,
    components: {
        MAccordionContent
    },
    props: {
        name: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    }
};

export default baseAccordionContent;
